import React, { useEffect } from 'react';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import autosize from 'autosize';
import './contact.scss';

const Contact = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const subject = encodeURIComponent(`Project enquiry from ${data.get('name')}`);
    const body = encodeURIComponent(`Name: ${data.get('name')}\nEmail: ${data.get('email')}\nPhone: ${data.get('phone') || 'Not provided'}\nCompany: ${data.get('company') || 'Not provided'}\nBudget: ${document.getElementById('unick-amount')?.value || 'To be determined'}\n\nProject details:\n${data.get('details')}`);
    window.location.href = `mailto:info@kodexsolutions.se?subject=${subject}&body=${body}`;
  };

  useEffect(() => {
    const slider = document.getElementById('unick-slider-range-min');
    const amount = document.getElementById('unick-amount');
    if (!slider || !amount) return undefined;
    if (slider.noUiSlider) slider.noUiSlider.destroy();
    noUiSlider.create(slider, { start: 0, connect: [true, false], range: { min: 0, max: 150000 }, step: 5000 });
    slider.noUiSlider.on('update', (values) => {
      const value = parseInt(values[0], 10);
      amount.value = value === 0 ? 'To be determined' : value === 150000 ? 'SEK 150,000+' : `SEK ${value.toLocaleString('en-US')}`;
    });
    const textareas = document.querySelectorAll('#contact textarea');
    autosize(textareas);
    return () => { if (slider.noUiSlider) slider.noUiSlider.destroy(); autosize.destroy(textareas); };
  }, []);

  return (
    <section className="contact-container" id="contact">
      <div className="contact-glow" aria-hidden="true" />
      <div className="contact-inner">
        <div className="contact-story">
          <span className="contact-eyebrow">START A CONVERSATION</span>
          <h2>Tell us what you are building. We will help make it clear.</h2>
          <p>Share the idea, challenge or next step. We will respond with honest guidance and a practical way forward—without unnecessary complexity.</p>
          <div className="contact-details">
            <a href="mailto:info@kodexsolutions.se"><span>Email</span><strong>info@kodexsolutions.se</strong></a>
            <a href="tel:+46700484114"><span>Phone</span><strong>+46 70 048 41 14</strong></a>
          </div>
          <div className="contact-promise">
            <span>01</span><p>Direct contact</p><span>02</span><p>Clear next steps</p><span>03</span><p>No-pressure conversation</p>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-form-top"><span>PROJECT ENQUIRY</span><small>Usually answered within one business day</small></div>
          <div className="contact-fields">
            <label><span>Your name *</span><input name="name" placeholder="How should we address you?" required type="text" /></label>
            <label><span>Email *</span><input name="email" placeholder="you@company.com" required type="email" /></label>
            <label><span>Phone</span><input name="phone" placeholder="Optional" type="tel" /></label>
            <label><span>Company</span><input name="company" placeholder="Company or organisation" type="text" /></label>
          </div>
          <div className="contact-budget">
            <div><span>Estimated budget</span><input type="text" id="unick-amount" readOnly aria-label="Estimated budget" /></div>
            <div id="unick-slider-range-min" aria-label="Select estimated project budget" />
          </div>
          <label className="contact-message"><span>Tell us about your project *</span><textarea name="details" placeholder="What are you looking to create, improve or solve?" required /></label>
          <button className="contact-submit" type="submit">Send enquiry <span aria-hidden="true">→</span></button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
